import { render, staticRenderFns } from "./ProjectSharedDialog.vue?vue&type=template&id=3088963c&scoped=true&"
import script from "./ProjectSharedDialog.vue?vue&type=script&lang=ts&"
export * from "./ProjectSharedDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSharedDialog.vue?vue&type=style&index=0&id=3088963c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3088963c",
  null
  
)

export default component.exports